import { StyleSheet } from 'react-native';

import { blackTransparent } from 'utils/colors';
import { dimensionsToAspectRatio } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        position: 'absolute',
        width: '100%',
        aspectRatio: dimensionsToAspectRatio(360, 96),
        bottom: 0,
    },
    left: {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '100%',
    },
    bottom: {
        position: 'absolute',
        top: '33.33%',
        left: 0,
        bottom: 0,
        width: '100%',
    },
    top: {
        opacity: 0.7,
        position: 'absolute',
        width: '100%',
        height: 96,
        top: 0,
    },
});

export const phoneBottomColors = [
    blackTransparent(0),
    blackTransparent(0.0086),
    blackTransparent(0.0355),
    blackTransparent(0.0816),
    blackTransparent(0.1474),
    blackTransparent(0.2317),
    blackTransparent(0.3318),
    blackTransparent(0.4426),
    blackTransparent(0.5573),
    blackTransparent(0.6681),
    blackTransparent(0.7682),
    blackTransparent(0.8525),
    blackTransparent(0.9183),
    blackTransparent(0.9645),
    blackTransparent(0.9914),
    '#000000',
];
export const phoneBottomLocations = [
    0, 0.06, 0.13, 0.2, 0.26, 0.3, 0.4, 0.46, 0.53, 0.6, 0.66, 0.73, 0.8, 0.86,
    0.93, 1,
];
export const tabletLeftStart = { x: 0, y: 1 };
export const tabletAngleCenter = { x: 0.5, y: 0 };
export const tabletLeftColors = [
    '#000000',
    blackTransparent(0.99),
    blackTransparent(0.96),
    blackTransparent(0.91),
    blackTransparent(0.85),
    blackTransparent(0.76),
    blackTransparent(0.66),
    blackTransparent(0.55),
    blackTransparent(0.44),
    blackTransparent(0.33),
    blackTransparent(0.23),
    blackTransparent(0.14),
    blackTransparent(0.08),
    blackTransparent(0.03),
    blackTransparent(0.008),
    blackTransparent(0),
];
export const tabletLeftLocations = [
    0, 0.25, 0.27, 0.3, 0.33, 0.36, 0.4, 0.46, 0.53, 0.6, 0.66, 0.73, 0.8, 0.86,
    0.93, 1,
];
export const tabletBottomColors = [
    blackTransparent(0),
    blackTransparent(0.008),
    blackTransparent(0.03),
    blackTransparent(0.08),
    blackTransparent(0.14),
    blackTransparent(0.23),
    blackTransparent(0.33),
    blackTransparent(0.44),
    blackTransparent(0.55),
    blackTransparent(0.66),
    blackTransparent(0.76),
    blackTransparent(0.85),
    blackTransparent(0.91),
    blackTransparent(0.96),
    blackTransparent(0.99),
    '#000000',
];
export const tabletBottomLocations = [
    0, 0.06, 0.13, 0.2, 0.26, 0.33, 0.4, 0.46, 0.53, 0.6, 0.66, 0.73, 0.8, 0.86,
    0.93, 1,
];

export default styles;
